import { css } from '@emotion/react'
import styled from '@emotion/styled'

const Container = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  gap: 10px;
  ${props =>
    props.align === 'right' &&
    css`
      flex-direction: row-reverse;
    `}
`

export const SpacingContainer = ({ children, align = 'left', ...props }) => {
  const normalizedChildren = align === 'left' ? children : children.slice().reverse()

  return <Container {...props}>{normalizedChildren}</Container>
}
